import script from "./ScheduleCollapse.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleCollapse.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleCollapse.vue?vue&type=style&index=0&id=28edeb48&lang=scss"

const __exports__ = script;

export default __exports__